import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Typography
} from '@mui/material';
import { THEME_COLORS, TYPOGRAPHY, ANIMATIONS } from '../constants';

/**
 * Composant pour les boutons d'action
 */
const ActionButtons = ({
  selectedActivity,
  participantsCount,
  isSubmitting,
  onAddParticipant,
  onSubmitAll
}) => {
  if (!selectedActivity) return null;

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: { xs: 'column', sm: 'row' }, 
      gap: { xs: 2, sm: 3 }, 
      alignItems: 'center',
      justifyContent: 'center',
      mt: { xs: 3, sm: 4 }
    }}>
      {/* Bouton Ajouter un participant plus fin */}
      <Button
        variant="contained"
        size="large"
        onClick={onAddParticipant}
        sx={{
          px: { xs: 3, sm: 4 },
          py: { xs: 1.5, sm: 2 },
          fontSize: { xs: TYPOGRAPHY.fontSize.base, sm: TYPOGRAPHY.fontSize.base },
          fontWeight: TYPOGRAPHY.fontWeight.semibold,
          fontFamily: TYPOGRAPHY.fontFamily.primary,
          textTransform: 'none',
          borderRadius: { xs: 3, sm: 4 },
          background: THEME_COLORS.primary.gradient,
          color: 'white',
          border: 'none',
          boxShadow: THEME_COLORS.shadow.md,
          transition: ANIMATIONS.transition.normal,
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(135deg, rgba(255,255,255,0.2) 0%, transparent 50%)',
            opacity: 0,
            transition: ANIMATIONS.transition.fast
          },
          '&:hover': {
            transform: { xs: 'none', sm: 'translateY(-2px)' },
            boxShadow: { xs: THEME_COLORS.shadow.lg, sm: THEME_COLORS.shadow.xl },
            '&::before': {
              opacity: 1
            }
          },
          '&:active': {
            transform: 'translateY(0px)'
          }
        }}
        startIcon={
          <Typography sx={{ fontSize: { xs: '1rem', sm: '1.2rem' } }}>👥</Typography>
        }
      >
        Ajouter un participant
      </Button>

      {/* Bouton Finaliser côte à côte sur desktop */}
      {participantsCount > 0 && (
        <Box sx={{ 
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1
        }}>

          <Button
            variant="contained"
            size="large"
            onClick={onSubmitAll}
            disabled={isSubmitting}
            sx={{
                px: { xs: 3, sm: 4 },
                py: { xs: 1.5, sm: 2 },
              fontSize: { xs: TYPOGRAPHY.fontSize.base, sm: TYPOGRAPHY.fontSize.base },
              fontWeight: TYPOGRAPHY.fontWeight.bold,
              fontFamily: TYPOGRAPHY.fontFamily.primary,
              textTransform: 'none',
              borderRadius: { xs: 3, sm: 4 },
              background: isSubmitting ? 
                THEME_COLORS.text.muted : 
                THEME_COLORS.success.gradient,
              color: 'white',
              border: 'none',
              boxShadow: isSubmitting ? 
                'none' : 
                `0 4px 20px ${THEME_COLORS.success.main}30`,
              transition: ANIMATIONS.transition.normal,
              position: 'relative',
              overflow: 'hidden',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(135deg, rgba(255,255,255,0.2) 0%, transparent 50%)',
                opacity: 0,
                transition: ANIMATIONS.transition.fast
              },
              '&:hover:not(:disabled)': {
                transform: { xs: 'none', sm: 'translateY(-2px)' },
                boxShadow: { 
                  xs: `0 6px 24px ${THEME_COLORS.success.main}35`,
                  sm: `0 8px 32px ${THEME_COLORS.success.main}40`
                },
                '&::before': {
                  opacity: 1
                }
              },
              '&:active:not(:disabled)': {
                transform: 'translateY(0px)'
              },
              '&:disabled': {
                cursor: 'not-allowed',
                opacity: 0.7
              }
            }}
            startIcon={isSubmitting ? 
              <CircularProgress size={18} sx={{ color: 'white' }} /> : 
              <Typography sx={{ fontSize: { xs: '1.1rem', sm: '1.3rem' } }}>🚀</Typography>
            }
          >
            {isSubmitting ? 
              'Inscription en cours...' : 
              'Finaliser l\'inscription'
            }
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ActionButtons;